import React from "react";
import HeroSection from "./Hero";
import Ticker from "./Ticker";
import HomeServices from "./Home-Services";
import HomeAbout from "./Home-about";
import HomePortfolio from "./Home-Portfolio";
import TechLogo from "./tech-logo";
import VideoSection from "./Reviews";
import UsHome from "./Whyus";
const Home = ()=>{
    return(<>
    
        <HeroSection/>
        <Ticker/>
        <HomeServices/>
        <HomeAbout/>
        <HomePortfolio/>
        <TechLogo/>
        <VideoSection/>
        <UsHome/>
    </>)
}
export default Home;